import { render, staticRenderFns } from "./HeaderSearch.vue?vue&type=template&id=64cc95a8&scoped=true&"
import script from "./HeaderSearch.vue?vue&type=script&lang=js&"
export * from "./HeaderSearch.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSearch.vue?vue&type=style&index=0&id=64cc95a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cc95a8",
  null
  
)

export default component.exports